<template>
<div id="statslabels" class="right-content">
  <el-form :model="filters" class="head-form">
    <el-row type="flex" justify="center" :gutter="20">
      <el-col :xs="6" :sm="6" :md="6" :lg="4">
        <el-form-item prop="category">
          <el-date-picker
            v-model="filters.daterange"
            type="daterange"
            align="right"
            placeholder="选择日期范围"
            @change="handleDateRangeChange"
            :picker-options="pickerOptions2">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :xs="16" :sm="16" :md="16" :lg="10">
      </el-col>
    </el-row>
  </el-form>
  <el-row type="flex" justify="center" :gutter="20">
    <el-col :xs="24" :sm="24" :md="22" :lg="14">
      <el-card class="box-card">
        <el-table
          :data="formatListData"
          stripe
          border
          v-loading="getLoadingStatus"
          element-loading-text="玩命加载中..."
          style="width: 100%">
          <el-table-column
            prop="id"
            label="id"
            width="240">
          </el-table-column>
          <el-table-column
            label="标签名"
            min-width="120">
            <template slot-scope="scope">
              <!-- <el-icon name="time"></el-icon>
              <span style="margin-left: 10px">{{ scope.row.name }}</span> -->

              <el-input
                :id = "scope.row.id"
                class="input-new-tag"
                v-if="scope.row.inputVisible"
                v-model="scope.row.name"
                size="mini"
                @keyup.enter.native="handleNameInputConfirm(scope.$index, scope.row)"
                @blur="handleNameInputBlur(scope.$index, scope.row)"
              >
              </el-input>
              <el-button v-else class="button-new-tag" size="small"  @click.native.prevent="showInput(scope.$index, scope.row)">{{ scope.row.name }}</el-button>

            </template>

          </el-table-column>
          <el-table-column
            prop="birthday"
            label="生成日期"
            width="180">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="100">
            <template slot-scope="scope">
              <!-- <el-button @click.native.prevent="handleEditClick(scope.$index, labellist)" type="text" size="small">编辑</el-button> -->
              <el-button @click.native.prevent="handleDelClick(scope.$index, labellist)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>


    </el-col>
  </el-row>

      <!--分页-->
  <div class="nav-pagin">
    <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="24" :md="22" :lg="14" class="el-item shadow">
        <el-pagination layout="total, prev, pager, next, jumper" :current-page.sync="page" @current-change="handlePageChange" :page-size="limit" :total="labeltotal">
        </el-pagination>
      </el-col>
    </el-row>
  </div>

</div>
</template>

<script type="text/javascript">
/**
 * 销售数据概览页组件
 */
import {mapGetters, mapActions} from 'vuex';
import { getNowTime, routeMap, cloneObj } from '../../utils/com.js'
import '../../static/style/stats/labels.scss'
import { newsType, hotsType, newsPlatform, auditFullType } from '../../config/config'
import { Loading } from 'element-ui';
import emptyCont from '../common/emptycontent.vue'
import contentList from '../common/contentlist.vue'

export default {
    data() {
        return {
            pickerOptions2: {
              disabledDate(time) {
                return time.getTime() > Date.now();
              },
              shortcuts: [{
                text: '最近一周',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近一个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近三个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                  picker.$emit('pick', [start, end]);
                }
              }]
            },
            filters: {
                daterange: '',
                start: '',
                end: '',
            },
            newloading: false,
            show: true,
            currentDate: new Date(),
            date: getNowTime(),
            page: 1,
            limit: 10,
            clientid: 1,


            editFormVisible: false, //编辑界面显是否显示
            editFormTtile: '编辑', //编辑界面标题
            //编辑界面数据
            editForm: {
              name: '',
            },
            editLoading: false,
            btnEditText: '提 交',
            editFormRules: {
              name: [{
                required: true,
                message: '请输入房间名称',
                trigger: 'blur'
              }]
            },

            inputVisible: false,
            inputValue: '',

            dynamicTags: ['标签一', '标签二', '标签三'],
            inputVisible: false,
            inputValue: '',
            autofocusVal: true,

        }
    },
    created() {
        // this.page = 1;
        // this.filters.start = '2017-09-01';
        // this.filters.end = '2017-09-13';
        this.reqLabelList();
    },
    watch: {
        '$route' (to, from){
            console.debug("watch>route start to:%o, from:%o", to, from);
            console.debug("watch>route limit:%o, page:%o, start:%o, end:%o", this.$route.query.limit, this.$route.query.page, this.$route.query.start, this.$route.query.end);
            let curpage = this.$route.query.page || 1;
            this.page = parseInt(curpage);
            let limit = this.$route.query.limit || 10;
            this.limit = parseInt(limit);
            this.filters.start = this.$route.query.start || '';
            this.filters.end = this.$route.query.end || '';
            this.reqLabelList();
        }
    },
    computed: {
        ...mapGetters({
            // 映射 this.statsdata 为 store.getters.statsdata
            statsdata: 'statsdata',
            statstotal: 'statstotal',
            getAccesstoken: 'getAccesstoken',
            getAppid: 'getAppid',
            getRole: 'getRole',
            labellist: 'labellist',
            labeltotal: 'labeltotal',
            getLoadingStatus: 'getLoadingStatus'
        }),
        formatListData: function () {
              // `this` points to the vm instance
              let lists = [];
              // console.debug("formatListData> statsdata:%o", this.statsdata);
              for(let i in this.labellist){
                let l = {};
                let newdata = this.labellist[i];

                l = cloneObj(newdata);
                l.inputVal = '';
                l.inputVisible = false;
                // console.debug("formatListData> newsData:%o, ls:%o", newdata, ls);
                lists.push(l);
              }
              console.debug("formatListData> lists:%o", lists);
              return lists;
            }
    },
    methods: {
        ...mapActions({
          // 映射 this.getEditorData() 为 this.$store.dispatch('getEditorData')
          getConsoleNews: 'getConsoleNews',
          updateLoadingStatus: 'updateLoadingStatus',
          getNewStatis: 'getNewStatis',
          getConsoleEvent: 'getConsoleEvent',
          updateNewsContent: 'updateNewsContent',
          getLabelList: 'getLabelList',
          updateLabel: 'updateLabel',
          deleteLabel: 'deleteLabel',
          delLabel: 'delLabel'
        }),
        reqLabelList(){
          var that = this;
          let param = {
              start: that.filters.start,
              end: that.filters.end,
              page: that.page,
              limit: that.limit,
          }
          console.debug("reqLabelList> param:%o", param);
          that.updateLoadingStatus(true);
          that.getLabelList(param).then(
            (resp) => {
              that.updateLoadingStatus(false);
              console.debug("reqLabelList> resp:%o", resp);
              if(resp && resp.code !== 0){
                that.$message({
                      message: resp.msg,
                      type: 'error'
                  });
              }
            }
          );
        },
        reqUpdateLabel(id, labelname){
          var that = this;
          let param = {
              id: id,
              labelname: labelname
          }
          console.debug("updateLabel> param:%o", param);
          that.updateLoadingStatus(true);
          that.updateLabel(param).then(
            (resp) => {
              that.updateLoadingStatus(false);
              console.debug("updateLabel> resp:%o", resp);
              if(resp && resp.code !== 0){
                that.$message({
                      message: resp.msg,
                      type: 'error'
                  });
              }else if(resp && resp.code === 0){
                that.$message({
                      message: resp.msg,
                      type: 'success'
                  });
              }
            }
          );
        },
        reqDelLabel(id){
          var that = this;
          let param = {
              id: id
          }
          console.debug("reqDelLabel> param:%o", param);
          that.updateLoadingStatus(true);
          that.delLabel(param).then(
            (resp) => {
              that.updateLoadingStatus(false);
              console.debug("reqDelLabel> resp:%o", resp);
              if(resp && resp.code !== 0){
                that.$message({
                      message: resp.msg,
                      type: 'error'
                  });
              }else if(resp && resp.code === 0){
                that.$message({
                      message: resp.msg,
                      type: 'success'
                  });
                // that.$router.push({ path: routeMap('/stats/labels'), query: { page: that.page, limit: that.limit, start:that.filters.start, end: that.filters.end} });
                that.reqLabelList();
              }
            }
          );
        },

        handleEditClick(index, rows) {
          console.debug("handleEditClick> index:%o, rows:%o", index, rows);
        },

        handleDelClick(index, rows) {
          console.debug("handleDelClick> index:%o, rows:%o", index, rows);
          var _this = this;
          this.$confirm('您确认 删除 此条标签吗?', '提示', {
            //type: 'warning'
          }).then(() => {
            this.reqDelLabel(rows[index].id);
          }).catch(() => {

          });


        },

        showInput(index, rows) {
          console.debug("showInput> index:%o, rows:%o", index, rows);
          rows.inputVisible = true;
          this.inputValue = rows.name;
          // console.debug("before showInput> saveTagInput:%o, inputValue:%o",this.$refs.saveTagInput, this.inputValue);
          this.$nextTick(_ => {
            // console.debug("after showInput> input:%o", this.$refs.saveTagInput.$refs.input);
            let x=document.getElementById(rows.id);
            // console.debug("showInput> x:%o, input", x, x.getElementsByTagName("input")[0]);
            x.getElementsByTagName("input")[0].focus();
            // this.$refs.saveTagInput.$refs.input.focus();
          });
          console.debug("showInput> inputVisible:%o, inputValue:%o", rows.inputVisible, rows.inputValue);
        },

        handleNameInputConfirm(index, rows) {
          // console.debug("handleNameInputConfirm> index:%o, rows:%o", index, rows);
          // if( this.inputValue !== rows.name){
          //   console.debug("handleNameInputConfirm> value change, old:%s, new:%s", this.inputValue, rows.name);
          //   this.reqUpdateLabel(rows.id, rows.name);
          // }else{
          //   console.debug("handleNameInputConfirm> nothing change");
          // }
          rows.inputVisible = false;
          rows.inputValue = '';
          this.inputValue = '';
          console.debug("handleNameInputConfirm> inputVisible:%o, inputValue:%o", rows.inputVisible, rows.inputValue);
        },
        handleNameInputBlur(index, rows) {
          console.debug("handleNameInputBlur> index:%o, rows:%o", index, rows);
          if( this.inputValue !== rows.name){
            console.debug("handleNameInputBlur> value change, old:%s, new:%s", this.inputValue, rows.name);
            this.reqUpdateLabel(rows.id, rows.name);
          }else{
            console.debug("handleNameInputBlur> nothing change");
          }
          rows.inputVisible = false;
          rows.inputValue = '';
          this.inputValue = '';
          console.debug("handleNameInputBlur> inputVisible:%o, inputValue:%o", rows.inputVisible, rows.inputValue);
        },

        handleDateRangeChange(val) {
          console.debug("handleDateRangeChange> val:%o, daterange:%o", val, this.filters.daterange);
          this.filters.start = val.split(' - ')[0];
          this.filters.end = val.split(' - ')[1];
          // this.page = 1;
          // this.reqLabelList();
          this.$router.push({ path: routeMap('/stats/labels'), query: { page: this.page, limit: this.limit, start:this.filters.start, end: this.filters.end} });
        },
        handlePageChange(val) {
          console.debug("handlePageChange> val:%o, page", val, this.page);
          // if(this.page !== val){
          //   this.page = val;
          // }
          this.$router.push({ path: routeMap('/stats/labels'), query: { page: this.page, limit: this.limit, start:this.filters.start, end: this.filters.end} });

        },


    },
    components: {
      emptyCont,
      contentList
    }
}
</script>



// WEBPACK FOOTER //
// labels.vue?08d45786